import { Order } from '@/coreDomainsModule/entities/order';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { BulkUpdateOrderEtaInfo } from '@/coreInfrastructureModule/axios/generated/orderManage';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { IOrderRepository } from '@/coreInfrastructureModule/interfaces/IOrderRepository';

/**
 * 発注納期を一括更新するユースケース
 */
export class BulkUpdateOrderEtaUseCase {
  private repository: IOrderRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IOrderRepository) {
    this.repository = repository;
  }

  /**
   * 発注納期を一括更新する
   * @param orders - 発注情報
   * @param eta - 変更する納期
   * @param applyToGroup - 関連するグループの発注にも適用するかどうか
   */
  public async execute(orders: Order[], eta: number, applyToGroup = false): Promise<INetworkResult<undefined, IError>> {
    try {
      const request: BulkUpdateOrderEtaInfo = {
        orderInfos: orders.map((o) => ({ orderId: o.orderId, updateAt: o.updatedAt })),
        estimatedTimeOfArrival: DateService.formatDateToISOString(DateService.convertMSUnixTimeToDate(eta)),
        applyToGroup: applyToGroup,
      };
      const response = await this.repository.bulkUpdateEta({ updateEtaInfo: request });

      switch (response.status.type) {
        case 'success':
          return {
            status: {
              type: 'success',
              data: undefined,
            },
          };
        case 'error':
          return {
            status: {
              type: 'error',
              error: response.status.error,
            },
          };
        default:
          throw new Error('Invalid status');
      }
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: {
            statusCode: 500,
            code: 'unknown',
            message: 'An unexpected error occurred',
          },
        },
      };
    }
  }
}
